import React from 'react'
import { Field } from 'redux-form/immutable'
import { fromJS } from 'immutable'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

import Input from 'app/components/Input'
import Delete from 'app/components/SVGS/Delete'
import IconButton from 'app/domains/common/IconButton'
// @ts-ignore
import { exclusionSpecialSymbolsForUserName } from 'helpers/exclusionSpecialSymbols'

import './styles.scss'

const bc = 'peer-invite-inputs'

const PeerInviteInputs = ({ t, fields }: any) => {
  return (
    <div className={`${bc}__inputs-wrapper`}>
      <div className={`${bc}__inputs`}>
        {fields.map((userForInvite: any, index: number) => (
          <div className={`${bc}__inputs-row`} key={index}>
            <Field
              name={`${userForInvite}.email`}
              type="email"
              id="admin-organization-users-invite-inputs-input-email"
              placeholder={t('Email')}
              component={Input}
              autoFocus={index !== 1 && index !== 2}
              className={classNames(`${bc}__input-wrapper`, `${bc}__input-email`)}
              inputClass={`${bc}__input`}
            />
            <Field
              name={`${userForInvite}.firstName`}
              id="admin-organization-users-invite-inputs-input-first-name"
              placeholder={t('First Name')}
              normalize={exclusionSpecialSymbolsForUserName}
              component={Input}
              className={classNames(`${bc}__input-wrapper`, `${bc}__input-option`)}
              inputClass={`${bc}__input`}
            />
            <Field
              name={`${userForInvite}.lastName`}
              id="admin-organization-users-invite-inputs-input-last-name"
              placeholder={t('Last Name')}
              normalize={exclusionSpecialSymbolsForUserName}
              component={Input}
              className={classNames(`${bc}__input-wrapper`, `${bc}__input-option`)}
              inputClass={`${bc}__input`}
            />
            <IconButton
              onClick={() => fields.length > 1 && fields.remove(index)}
              disabled={fields.length === 1}
              style={{ marginTop: '4px' }}
            >
              <Delete />
            </IconButton>
          </div>
        ))}
      </div>
      <div className={`${bc}__links`}>
        <span className={`${bc}__links-item`} onClick={() => fields.push(fromJS({}))}>
          {`+ ${t('admin:Add another')}`}
        </span>
      </div>
    </div>
  )
}

export default withTranslation(['common', 'admin'])(PeerInviteInputs)
